import { useController } from 'react-hook-form';
import { useEvent } from './useEvent';
import { mapValidationRules } from './rules';
const defaultFormat = (value) => (value == null ? '' : value);
const defaultParse = (value) => (value === '' ? null : value);
export const useInput = (props) => {
    const { defaultValue, name, onBlur: initialOnBlur, onChange: initialOnChange, format = defaultFormat, parse = defaultParse, multiple, errorKey, rules = [], disabled, } = props;
    const { field: controllerField, fieldState, formState, } = useController({
        name,
        defaultValue,
        rules: mapValidationRules(errorKey, rules),
        disabled: disabled || undefined,
    });
    const onBlur = useEvent((...event) => {
        controllerField.onBlur();
        if (initialOnBlur) {
            initialOnBlur(...event);
        }
    });
    const onChange = useEvent((...event) => {
        let eventOrValue;
        if (props.type == 'checkbox' && event[0]?.target?.value === 'on') {
            eventOrValue = event[0].target.checked;
        }
        else if (props.type == 'select') {
            eventOrValue = multiple ? event[0].map((ev) => ev.value) : event[0]?.value;
        }
        else {
            eventOrValue = event[0]?.target?.value ?? event[0];
        }
        controllerField.onChange(parse ? parse(eventOrValue) : eventOrValue);
        if (initialOnChange) {
            initialOnChange(...event);
        }
    });
    const field = {
        ...controllerField,
        value: format ? format(controllerField.value) : controllerField.value,
        onBlur,
        onChange,
    };
    return {
        field,
        fieldState,
        formState,
    };
};
//# sourceMappingURL=useInput.js.map